import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/login.scss";
import "../../css/phoneInput.scss";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { message } from "antd";
import { login } from "../../apis/Login";
import Cookies from "js-cookie";

const Login = () => {
  const navigate = useNavigate();
  const [loginType, setLoginType] = useState("phone");
  const [showPassword, setShowPassword] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryData, setCountryData] = useState(null); // 存储国家信息
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    captcha: "",
  });

  // 处理输入变化
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // 登录处理
  const handleLogin = async () => {
    setLoading(true);

    // 获取登录账号（邮箱或手机号）
    let loginAccount = loginType === "phone" ? phoneNumber : formData.email;

    // 先验证账号
    if (loginType === "phone") {
      // 手机登录：检查手机号是否有效（不只是国家代码）
      if (!phoneNumber || phoneNumber.length <= 2) {
        message.error("请输入手机号");
        setLoading(false);
        return;
      }

      // ✅ 处理手机号格式：去除所有国家代码前缀
      if (countryData && countryData.dialCode) {
        const dialCode = countryData.dialCode;
        // 如果号码以国家代码开头，去除它
        if (phoneNumber.startsWith(dialCode)) {
          loginAccount = phoneNumber.substring(dialCode.length);
        } else {
          loginAccount = phoneNumber;
        }
      } else {
        // 如果没有国家信息，使用原号码
        loginAccount = phoneNumber;
      }
    } else {
      // 邮箱登录：检查邮箱是否为空
      if (!loginAccount) {
        message.error("请输入邮箱");
        setLoading(false);
        return;
      }
    }

    // 再验证密码
    if (!formData.password) {
      message.error("请输入密码");
      setLoading(false);
      return;
    }

    try {
      // 调用登录接口
      const response = await login(loginAccount, formData.password);

      console.log("📥 登录响应：", response);

      if (response && response.data && response.data.code === 200) {
        const { token, user } = response.data.data || {};

        // 存储 token 和用户信息到 cookie (7天过期)
        Cookies.set("token", token, { expires: 7 });
        if (user) {
          Cookies.set("user", JSON.stringify(user), { expires: 7 });
        }

        message.success("登录成功！");

        // 跳转到主页或仪表板
        navigate("/userAccount"); // 根据您的路由修改
      } else {
        // 登录失败
        const errorMsg = response.data?.message || "登录失败";
        message.error(errorMsg);
      }
    } catch (error) {
      console.error("登录失败：", error);
      console.error("错误详情：", error.response);
      // 显示错误信息
      const errorMsg =
        error.response?.data?.message || error.message || "网络错误，请重试";
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // 支持Enter键登录
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="login_box">
      <div className="login_box_left">
        <img alt="Login Background" src="/main/login.jpg" />
      </div>
      <div className="login_box_right">
        {/* 主登录区域 */}
        <div className="login_main_content">
          {/* Logo */}
          <div className="logo_section">
            <div className="logo_circle">
              <span>
                <img alt="" src="/main/login5.png" />
              </span>
            </div>
            <h1 className="app_title">Global E-Payment</h1>
          </div>

          {/* 登录方式切换 */}
          <div className="login_tabs">
            <div
              className={`tab ${loginType === "phone" ? "active" : ""}`}
              onClick={() => setLoginType("phone")}
            >
              手机登录
            </div>
            <div
              className={`tab ${loginType === "email" ? "active" : ""}`}
              onClick={() => setLoginType("email")}
            >
              登录邮箱/用户名登录
            </div>
          </div>

          {/* 登录表单 */}
          <div className="login_form">
            {/* 手机号/邮箱输入 */}
            <div className="input_group">
              {loginType === "phone" ? (
                <div className="input_wrapper phone_number_wrapper">
                  <img alt="" src="/main/login6-1.png" className="phone_icon" />
                  <PhoneInput
                    country={"cn"}
                    value={phoneNumber}
                    onChange={(phone, country) => {
                      setPhoneNumber(phone);
                      setCountryData(country);
                    }}
                    placeholder="手机号码"
                    inputClass="phone_number_input"
                    containerClass="phone_input_container"
                    buttonClass="phone_country_button"
                    dropdownClass="phone_dropdown"
                    enableSearch={true}
                    searchPlaceholder="搜索"
                    disableSearchIcon={false}
                    buttonText={(country) => `+${country.dialCode}`}
                    onKeyPress={handleKeyPress} // ✅ 添加Enter支持
                  />
                </div>
              ) : (
                <div className="input_wrapper">
                  <img alt="" src="/main/login6-6.png" />
                  <input
                    type="email"
                    className="form_input"
                    placeholder="登录邮箱/用户名"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>
              )}
            </div>

            {/* 密码输入 */}
            <div className="input_group">
              <div className="input_wrapper">
                <img alt="" src="/main/login6-2.png" />
                <input
                  type={showPassword ? "text" : "password"}
                  className="form_input"
                  placeholder="登录密码"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                />
                <span
                  className="eye_icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <img alt="" src="/main/login6-5.png" />
                  ) : (
                    <img alt="" src="/main/login6-4.png" />
                  )}
                </span>
              </div>
            </div>

            {/* 登录按钮 */}
            <button
              type="button" // ✅ 防止表单提交导致页面刷新
              className="login_button"
              onClick={handleLogin}
              disabled={loading} // ✅ 加载时禁用按钮
            >
              {loading ? "LOGIN..." : "LOGIN"} {/* ✅ 显示加载状态 */}
            </button>
          </div>
        </div>

        {/* 页脚版权 */}
        <div className="login_footer">
          <p>© 2022 GLOBAL E-PAYMENT LIMITED. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
